// extracted by css-extract-rspack-plugin
export default {"columnHeader":"PSqwD","revisionsWrapper":"oygSj","schemaSeparator":"VVfmE cq5WZ yZ44O","tableActualName":"eXknW"};